/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import classnames from 'classnames';
import IntelligenceVideoPlayer, {
  PropTypes as IIntelligenceVideoPlayerProps,
} from '@intelligence/components/VideoPlayer';

import './index.scss';

interface IVideoPlayerProps extends IIntelligenceVideoPlayerProps {}

export interface IVideoPlayerInstance extends HTMLVideoElement {
  // 播放
  play: () => Promise<void>;
  // 暂停
  pause: () => void;
  // 获取player实例
  player: () => void;
}

const VideoPlayer: React.ForwardRefRenderFunction<IVideoPlayerInstance, IVideoPlayerProps> = (props, ref) => {
  const { style, className, options = {}, ...restProps } = props;

  // 合并默认配置和传入的配置
  const mergedOptions = {
    autoplay: true,
    ...options, // 允许外部覆盖配置
  };

  return (
    <IntelligenceVideoPlayer
      {...restProps}
      ref={ref}
      style={style}
      className={classnames('dba-video-player', className)}
      options={mergedOptions}
    />
  );
};

export default React.forwardRef(VideoPlayer);
